import Vue from "vue";
import OS from "framework/utils/OS";

import commonStyle from "../css/common.module.css";
import style from "../css/PopupHeader.module.css";

export default Vue.extend({
  props: {
    icon: String,
    handleClose: Function,
  },
  render() {
    return (
      <div class={[OS.desktop ? style.container : style.containerMobile]}>
        { this.handleClose ?
          <button class={style.button} onClick={this.handleClose}>
            <div class={[style.circleButton, commonStyle.buttonLabel]}>
              <img class={commonStyle.labelIcon} style="height: 1em" src="images/Cross_Grey.svg" />
            </div>
          </button>
          : null}
      </div>
    );
  },
});
